const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB5-iMeH2LTcdgUNjohb3fOgbdFaLhLrkk",
  authDomain: "myclients-kopagas.firebaseapp.com",
  databaseURL: "https://myclients-kopagas.firebaseio.com",
  projectId: "myclients-kopagas",
  storageBucket: "myclients-kopagas.appspot.com",
  messagingSenderId: "942933933082",
  appId: "1:942933933082:web:b871c56bef3e4b19f9e5a3",
  measurementId: "G-6C7QKTEYZT",
};

const VAPID_KEY = "BE8pZ3BglHeBSVIFvwCGNk1Fga4NjtFIQe1-jCyHxJX6Q4O_b15iun-Y3l2mRoxCAlnBa8gjYivG425ONkstrqE";

export { FIREBASE_CONFIG, VAPID_KEY };
